
import React from 'react';
import {
  FormItem,
  FormLabel,
  FormControl,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface RoleSelectorProps {
  role: string;
  setFormField: (field: string, value: any) => void;
}

const RoleSelector: React.FC<RoleSelectorProps> = ({
  role,
  setFormField
}) => {
  return (
    <div>
      <FormItem>
        <FormLabel htmlFor="role">Role</FormLabel>
        <FormControl>
          <Select
            value={role}
            onValueChange={(value) => setFormField('role', value)}
          >
            <SelectTrigger id="role">
              <SelectValue placeholder="Select a role" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="Owner">Owner</SelectItem>
              <SelectItem value="Manager">Manager</SelectItem>
            </SelectContent>
          </Select>
        </FormControl>
      </FormItem>
    </div>
  );
};

export default RoleSelector;
